import { Box } from 'braid-design-system';

import * as styles from './HorizontalRule.css';

export const HorizontalRule = () => (
  <Box className={styles.hr} component="hr" />
);
